import { requestMain, requestCommon } from '@/apis/index';

// 计算税后价格
export const getPriceWithTax = (data: Record<string, any>) => {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'common_amount_after_tax',
      },
      data,
    },
    true
  );
};

// 物品搜索
export const searchGoods = (keywords: string) => {
  return requestMain(
    '',
    {
      method: 'get',
      params: {
        _m: 'common_goods_search_by_keywords',
        keywords,
      },
    },
    true
  );
};

// 搬运费平台套餐计价配置
export const porterageConfig = (data: Record<string, any>) => {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.porterageConfig',
        data: {
          ...data,
          os: 'pc',
        },
      },
      showError: false,
    },
    true,
    'eoc'
  );
};

// 搬运费平台套餐计价配置
export const porterageCalcApi = (data: Record<string, any>) => {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.porterageCalculate',
        data: {
          ...data,
          os: 'pc',
        },
      },
    },
    true,
    'eoc'
  );
};

// 订单详情获取搬运费平台套餐计价结果 - 用于再来一单
export const porterageDetailCalcApi = (data: Record<string, any>) => {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.porterageBackfill',
        data: {
          ...data,
          os: 'pc',
        },
      },
    },
    false,
    'eoc'
  );
};
